import React from 'react';

import { useSelector } from 'react-redux';

import Style from '../Header.module.css';

import { Button } from '../../../atoms';

import { pushEventInLoggy } from '../../../../utils/loggy';

function HeaderInfoMob() {
  const { my_profile } = useSelector((state) => state);

  const handleEventTrigger = () => {
    pushEventInLoggy(
      {
        event: 'Reffer_via_WA_Browse_Job',
        page_name: 'Browse Job'
      },
      my_profile
    );
  };

  return (
    <div className={Style.headerContainer2}>
      <div className='padding32 padding0B relative-position'>
        <div>
          {my_profile?.data?.data ? <div>Hi {my_profile?.data?.data?.first_name} !</div> : null}
          Discover abundant job opportunities and enhance your productivity.
        </div>
        <a href='https://wa.me/919164277011?text=Refer%20and%20earn' onClick={handleEventTrigger}>
          <Button className='whatsapp-btn-2'>Refer via Whatsapp</Button>
        </a>
      </div>
      <img src='/images/job-dashboard/Cycling.png' />
    </div>
  );
}

export default HeaderInfoMob;
